import React from 'react';
import { Table } from 'antd';
import { useHistory } from 'react-router-dom';
import { logAuditTrailEvent } from 'services/system_setup/auditTrail';

const columns = [
	{
		title: 'CUSTOMER CODE',
		dataIndex: 'customer_code',
		key: 'customer_code',
		width: '25%',
		overflow: 'auto',
	},
	{
		title: 'CUSTOMER NAME',
		dataIndex: 'customer_name',
		key: 'customer_name',
		width: '60%',
	},
	{
		title: 'STATUS',
		dataIndex: 'status',
		key: 'status',
		width: '15%',
	},
];

function SearchCustTable(props) {
	const { data, pageSize } = props;
	const history = useHistory();

	const handleOpenRecord = (record) => {
		void logAuditTrailEvent({
			moduleCode: 'cust',
			subModuleCode: 'search',
			action: 'VIEW',
			description: `View customer record ${record && record.customer_code ? record.customer_code : ''}`.trim(),
			payload: {
				customer_id: record && record.customer_id,
				customer_code: record && record.customer_code,
			},
			isSuccess: 1,
		});
		history.push('/customer/update_customer', record);
	};
	return (
		<div>
			<Table
				// style={ {textTransform: "uppercase"} }'
				rowKey={record => record.customer_id}
				dataSource={data}
				columns={columns}
				bordered
				pagination={{pageSize}}
				onRow={(record) => {
                    return {
                        onDoubleClick: () => handleOpenRecord(record)
                    };
                }}
			/>
		</div>
	);
}

export default SearchCustTable;
